"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTealiumTrackingObject = formatTealiumTrackingObject;
const formatTealiumCompliantString_1 = require("./formatTealiumCompliantString");
const formatPrice_1 = require("./formatPrice");
/**
 * Die Funktion formatiert ein Objekt in ein Tealium-konformes Objekt:
 * - `null` oder `undefined` Werte werden ignoriert/entfernt
 * - `numbers` werden als Preis (z.B. '1.00') formatiert
 * - Strings werden Tealium-konform formatiert (mit Ausnahme der 'page_' Parameter, die bereits formatiert sein sollten)
 *
 * @category Utils
 * @param trackingObject
 * @returns Tealium-konformes Objekt
 */
function formatTealiumTrackingObject(trackingObject) {
    const parsedObject = {};
    const alreadyFormattedKeys = [
        'page_content_id',
        'page_contentgroup_1',
        'page_contentgroup_2',
        'page_contentgroup_3',
        'page_contentgroup_4',
        'page_contentgroup_5',
        'page_contentgroup_6',
        'page_contentgroup_7',
        'page_contentgroup_9',
        'page_type',
        'page_requested_url'
    ];
    Object.entries(trackingObject).forEach(([key, value]) => {
        if (value === null || value === undefined) {
            return;
        }
        if (alreadyFormattedKeys.includes(key)) {
            if (typeof value === 'string') {
                parsedObject[key] = value;
            }
            return;
        }
        parsedObject[key] = typeof value === 'number' ? (0, formatPrice_1.formatPrice)(value) : (0, formatTealiumCompliantString_1.formatTealiumCompliantString)(value);
    });
    return parsedObject;
}
